/* src/app/components/review/browse/browse.component.scss */
mat-form-field.open-search-bar {
  background: #fff;
}
:host-context(.dark-theme) mat-form-field.open-search-bar {
  background: #363636;
}
.selected-browse-icon {
  color: var(--palette-accent-default, #ffc107);
}
table[mat-table] th[mat-header-cell] {
  padding-left: 0;
  padding-right: 0;
}
table[mat-table] th[mat-cell] {
  padding-left: 0;
  padding-right: 0;
}
.mat-mdc-form-field-has-icon-prefix .mat-mdc-text-field-wrapper {
  padding-left: 0px;
}
.mat-mdc-card {
  margin: 16px 0;
  padding: 0;
  background: #fafafa;
}
.mat-mdc-card-content {
  background: white;
}
.custom-parent {
  border-left: 2px solid #e0e0e0;
}
:host-context(.dark-theme) .mat-mdc-card,
:host-context(.dark-theme) .mat-mdc-card-content {
  background: #363636;
}
:host-context(.dark-theme) .custom-parent {
  border-left: 2px solid rgba(255, 255, 255, 0.12);
}
.row-number-header {
  text-align: center;
  width: 50px;
}
.row-number {
  background-color: #F8F8F8;
  color: gray;
  text-align: center;
  padding: 0 10px;
}
.expanded-text {
  color: #ffc107;
}
.mat-mdc-list .mat-mdc-list-item {
  height: 20px;
}
th.mat-sort-header-sorted {
  color: black;
}
th.mat-mdc-header-cell {
  border-right: 1px solid #e0e0e0;
}
:host-context(.dark-theme) th.mat-mdc-header-cell {
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}
.resizable {
  height: 50px;
}
.table-header {
  margin-left: 5px;
  float: left;
  white-space: nowrap;
  position: absolute;
  z-index: -1;
}
.table-header:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}
.grip-handle {
  width: 5px;
  height: 100%;
  cursor: ew-resize;
  float: right;
  z-index: 1;
}
th.mat-mdc-header-cell:last-of-type,
td.mat-mdc-cell:last-of-type,
td.mat-mdc-footer-cell:last-of-type {
  padding-right: 0px;
}
.grip-handle:hover {
  background-color: lightgrey;
}
mat-expansion-panel {
  overflow: visible;
}
.table-width {
  min-width: 500px;
  table-layout: fixed;
}
a:link,
a:visited {
  color: rgb(63, 81, 181);
}
:host-context(.dark-theme) ::ng-deep .ddlLabel {
  color: #a5a5a5;
}
.no-wrap .mat-mdc-cell,
.mat-mdc-footer-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.word-wrap .mat-mdc-cell,
.mat-mdc-footer-cell {
  overflow-wrap: break-word;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.spinner-container {
  margin: auto;
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.spinner-container mat-spinner {
  margin: -25px auto 0 -25px;
}
:host ::ng-deep .mat-mdc-progress-spinner circle,
.mat-mdc-progress-spinner circle {
  stroke: #ffd54f;
}
.dim {
  background: rgba(0, 0, 0, 0.01);
  --mat-card-under-table-background: rgba(0, 0, 0, 0.01);
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.paging-container {
  margin-left: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-select {
  display: flex;
  align-items: center;
  font-size: 12px;
}
.page-select .page-text {
  width: 48px;
}
:host-context(.dark-theme) a,
:host-context(.dark-theme) a:visited {
  color: #88a3ff;
}
/*# sourceMappingURL=browse.component.css.map */
